// Coded by Narain on (11/09/2024)

const whyChooseImages = [
    'SVG-1.png', 'SVG-2.png','SVG-3.png','SVG-4.png'
];
  
  const svgs = whyChooseImages.map((image, index) => ({
    image: require(`../assets/images/landing/whychoose/${image}`),
    title: `Brand ${index + 1}`,
    description: `Description for Brand ${index + 1}.`,
    alt: `Brand ${index + 1}`
  }));
  
  export default svgs;
  